/* eslint-disable */
/*表单验证规则*/
//手机号码验证
export function validateTel (rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入手机号码'))
  } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
    callback(new Error('手机号码格式错误'))
  } else {
    callback()
  }
}
//手机号码验证格式非必填
export function validateTelTwo (rule, value, callback) {
  if (value !== '' && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
    callback(new Error('手机号码格式错误'))
  } else {
    callback()
  }
}
export function validateCarNo (rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入车牌号'))
  } else if (!(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/.test(value))) {
    callback(new Error('车牌号格式错误'))
  } else {
    callback()
  }
}
//身份证号码验证格式非必填
export function IDcardTwo (rule, value, callback) {
  if (value !== '' && !(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value))) {
    callback(new Error('身份证格式错误'))
  } else {
    callback()
  }
}
//身份证号码验证
export function IDcard (rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入身份证'))
  } else if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value))) {
    callback(new Error('身份证格式错误'))
  } else {
    callback()
  }
}
//邮箱验证
export function validateEmail (rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入邮箱'))
  } else if (!(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value))) {
    callback(new Error('邮箱格式错误'))
  } else {
    callback()
  }
}
//税号
export function TaxID (rule, value, callback) {
  if (value !== '' && !(/^[a-zA-Z0-9]{18}$/.test(value))) {
    callback(new Error('税号18位，格式错误'))
  } else {
    callback()
  }
}
//非数字验证
export function validateSort (rule, value, callback) {
  // if (value === '') {
  //   callback(new Error('请输入显示顺序'))
  // } else
  if (!(/^[0-9]*$/.test(value))) {
    callback(new Error('只能输入数字'))
  } else {
    callback()
  }
}
export function validateNo (rule, value, callback) {
  if (value === '') {
    callback(new Error('不能为空'))
  } else {
    callback()
  }
}
//表单验证规则
export function rule (list) {
  let rules = {}
  for (let key in list) {
    if (list[key].required && list[key].type === 'text') {
      rules[list[key].value] = [{ required: true, message: '请输入' + list[key].label.slice(0, list[key].label.length - 1), trigger: 'blur' }]
    }
    else if (list[key].required && list[key].type === 'select') {
      rules[list[key].value] = [{ required: true, message: '请选择' + list[key].label.slice(0, list[key].label.length - 1), trigger: 'change' }]
    }
  }
  return rules
}
/* eslint-disable */


// WEBPACK FOOTER //
// ./src/utils/rules.js